const pl_PL = {
  "colorpicker.opacity-input": "Nieprzezroczystość",
  "datepicker.clear-date": "Wyczyść datę",
  "datepicker.next-month": "Następny miesiąc",
  "datepicker.open-calendar": "Otwórz kalendarz",
  "datepicker.previous-month": "Poprzedni miesiąc",
  "input.clear": "Wyczyść pole wprowadzania",
  "input.hide-password": "Ukryj hasło",
  "input.show-password": "Pokaż hasło",
  "modal.close": "Zamknij",
  "multiselectchips.add-value": "Dodaj „{value}”",
  "multiselectchips.remove-all": "Usuń wszystko",
  "pagination.next-page": "Następna strona",
  "pagination.previous-page": "Poprzednia strona"
};
export {
  pl_PL as default
};
//# sourceMappingURL=pl_PL.json.js.map
